<div class="fh-head">
  <div class="fh-title">
    <h2 mat-dialog-title>{{ '@issueFaultHistoryTitle' | translate }}</h2>
    <div class="fh-asset">{{ data.assetName || data.vin }}<span *ngIf="data.assetName && data.vin">
      &nbsp;&middot;&nbsp;{{ data.vin }}</span></div>
  </div>
  <button type="button" class="fh-close" data-e2e="fault-history-close"
          [attr.aria-label]="'@close' | translate" (click)="close()">&times;</button>
</div>

<div class="fh-bar">
  <span class="fh-window">{{ '@issueFaultWindow' | translate: { days: spanDays } }}</span>
  <div class="fh-range">
    <label class="fh-range-label" for="fh-from">{{ '@issueFaultFrom' | translate }}</label>
    <input class="fhd-filter-input fh-date" id="fh-from" type="date"
           data-e2e="fault-history-from" [max]="today"
           [(ngModel)]="startDate" (change)="commitRange()" />
    <label class="fh-range-label" for="fh-to">{{ '@issueFaultTo' | translate }}</label>
    <input class="fhd-filter-input fh-date" id="fh-to" type="date"
           data-e2e="fault-history-to" [max]="today"
           [(ngModel)]="endDate" (change)="commitRange()" />
    <span class="fh-range-hint">{{ '@issueFaultRangeHint' | translate: { max: maxDays } }}</span>
  </div>
  <span class="fh-yaxis">{{ '@issueFaultYAxis' | translate }}</span>
</div>

<mat-dialog-content class="fh-content">
  <div class="fh-chart" (mousemove)="onPointerMove($event)" (mouseleave)="closeHover()">
    <svg class="fh-svg" [attr.viewBox]="viewBox" role="img"
         [attr.aria-label]="'@issueFaultChartAria' | translate: { days: spanDays }">
      <line *ngFor="let g of dayGrid" class="fh-grid"
            [attr.x1]="g.x1" [attr.x2]="g.x2" [attr.y1]="g.y1" [attr.y2]="g.y2"></line>
      <line *ngFor="let g of valueGrid" class="fh-grid"
            [attr.x1]="g.x1" [attr.x2]="g.x2" [attr.y1]="g.y1" [attr.y2]="g.y2"></line>
      <text *ngFor="let t of valueTicks" class="fh-axlabel"
            [attr.x]="plotLeft - 6" [attr.y]="t.y + 3" text-anchor="end">{{ t.label }}</text>

      <line class="fh-ax" [attr.x1]="plotLeft" [attr.x2]="plotRight"
            [attr.y1]="plotBottom" [attr.y2]="plotBottom"></line>
      <line class="fh-ax" [attr.x1]="plotLeft" [attr.x2]="plotLeft"
            [attr.y1]="plotTop" [attr.y2]="plotBottom"></line>

      <ng-container *ngFor="let line of lines">
        <!-- One path per run. The gap between them is a restart: the module began that run
             again, so a line drawn through it would carry the old count into the new one. -->
        <path *ngFor="let d of line.runs" class="fh-line"
              [attr.d]="d" [attr.stroke]="line.color"></path>
        <!-- Dashed: the count the fault still carries, held forward from its last report. -->
        <path *ngIf="line.tailD" class="fh-tail"
              [attr.d]="line.tailD" [attr.stroke]="line.color"></path>
        <ng-container *ngFor="let edge of line.edges">
          <line class="fh-edge" [attr.x1]="edge.x" [attr.x2]="edge.x"
                [attr.y1]="edge.top" [attr.y2]="plotBottom"></line>
          <circle class="fh-edgemark" [attr.cx]="edge.x" [attr.cy]="edge.y" r="3.6">
            <title>{{ edge.title }}</title>
          </circle>
        </ng-container>
      </ng-container>

      <!-- One lane per drawn fault: the dash lamp the module lit, held to the next report.
           On these rows severity always arrives as zero, so this is the only thing that
           says how bad the truck thought it was. -->
      <ng-container *ngFor="let lane of lanes">
        <rect class="fh-lanebg" [attr.x]="plotLeft" [attr.y]="lane.y"
              [attr.width]="plotRight - plotLeft" [attr.height]="laneHeight" rx="2"></rect>
        <rect [attr.x]="plotLeft - 6" [attr.y]="lane.y" width="4" [attr.height]="laneHeight"
              rx="1" [attr.fill]="lane.color"></rect>
        <rect *ngFor="let b of lane.blocks" [attr.x]="b.x" [attr.y]="lane.y"
              [attr.width]="b.width" [attr.height]="laneHeight" [attr.class]="'fh-lamp-' + b.lamp">
          <title>{{ b.title }}</title>
        </rect>
      </ng-container>

      <ng-container *ngIf="hoverOpen">
        <line class="fh-crosshair" [attr.x1]="hoverX" [attr.x2]="hoverX"
              [attr.y1]="plotTop" [attr.y2]="plotBottom"></line>
        <circle *ngFor="let dot of hoverDots" class="fh-hoverdot"
                [attr.cx]="hoverX" [attr.cy]="dot.cy" r="3.4" [attr.fill]="dot.color"></circle>
      </ng-container>

      <text *ngFor="let t of xTicks" class="fh-axlabel"
            [attr.x]="t.x" [attr.y]="labelY" text-anchor="middle">{{ t.label }}</text>

      <text *ngIf="!lines.length && !loading" class="fh-empty-mark"
            [attr.x]="(plotLeft + plotRight) / 2" [attr.y]="(plotTop + plotBottom) / 2"
            text-anchor="middle">
        {{ (series.length ? '@issueFaultNoneSelected' : '@issueFaultNoneReported') | translate }}
      </text>
    </svg>

    <!-- The only place a count is written: the chart carries no dots to hover one at a time.
         The lamp rides here too, because the lane it comes from is 11px tall. -->
    <div class="fh-readout" *ngIf="hoverOpen" [class.flip]="hoverFlip"
         [style.left.px]="hoverLeftPx">
      <div class="fh-r-time">{{ hoverAt | date: 'MMM d, h:mm a' }}</div>
      <div class="fh-r-row" *ngFor="let row of hoverRows">
        <span class="fh-r-sw" [style.background]="row.color"></span>
        <span class="fh-r-name">{{ row.name }}</span>
        <span class="fh-r-lamp" [ngClass]="'fh-lamp-' + row.lamp"
              [title]="row.lampTitle"></span>
        <span class="fh-r-seen">&times;{{ row.seen }}</span>
        <span class="fh-r-count">{{ row.count }}</span>
      </div>
    </div>
  </div>

  <div class="fh-legend">
    <span><i class="fh-lamp-3"></i>{{ '@issueFaultLampStop' | translate }}</span>
    <span><i class="fh-lamp-2"></i>{{ '@issueFaultLampWarning' | translate }}</span>
    <span><i class="fh-lamp-1"></i>{{ '@issueFaultLampMalfunction' | translate }}</span>
    <span><i class="fh-lamp-0"></i>{{ '@issueFaultLampNone' | translate }}</span>
    <span class="fh-legend-edge">{{ '@issueFaultRestartLegend' | translate }}</span>
    <span class="fh-hint">{{ '@issueFaultHoverHint' | translate }}</span>
  </div>

  <div class="fh-flat" *ngIf="flatNote">{{ flatNote }}</div>

  <div class="fh-listhead">
    <span class="fh-listlabel">{{ '@issueFaultListLabel' | translate }}</span>
    <span class="fh-listact" *ngIf="series.length">
      <button type="button" data-e2e="fault-history-all" (click)="setAll(true)">
        {{ '@issueFaultShowAll' | translate }}</button>
      <button type="button" data-e2e="fault-history-none" (click)="setAll(false)">
        {{ '@issueFaultHideAll' | translate }}</button>
    </span>
  </div>

  <div class="fh-shimmer" *ngIf="loading" aria-hidden="true"></div>

  <div class="fh-list" *ngIf="!loading && series.length">
    <label class="fh-row" *ngFor="let s of series; trackBy: trackSeries"
           [class.off]="!s.visible" [attr.data-e2e]="'fault-row-' + s.key">
      <input type="checkbox" [checked]="s.visible"
             [attr.aria-label]="s.label" (change)="toggle(s, $any($event.target).checked)" />
      <span class="fh-sw" [style.background]="s.color"></span>
      <!-- Two spans, because the qualifier is the whole reason the name is qualified. The
           base name gives way to the ellipsis; the failure mode never does. -->
      <span class="fh-name" [title]="s.label">
        <span class="fh-name-base">{{ s.name || s.codeLabel }}</span>
        <span class="fh-name-qualifier" *ngIf="s.qualifier">({{ s.qualifier }})</span>
      </span>
      <!-- Says why the box is already ticked, rather than leaving the reader to guess. -->
      <span class="fh-issue">
        <span class="fh-chip issue" *ngIf="s.triggered">{{ '@issueFaultOnIssue' | translate }}</span>
      </span>
      <span class="fh-code">{{ s.codeLabel }}</span>
      <span class="fh-worst" [ngClass]="'fh-lamp-' + s.worstLamp" [title]="s.worstLampTitle"></span>
      <span class="fh-eps" [title]="s.episodesTitle">
        <b *ngIf="s.episodes > 1">{{ s.episodes }}</b><span *ngIf="s.episodes === 1">1</span>&times;
      </span>
      <span><span class="fh-chip" [class.on]="s.active">
        {{ (s.active ? '@issueFaultActive' : '@issueFaultInactive') | translate }}</span></span>
      <span class="fh-count">{{ s.latestCount }}</span>
      <span class="fh-when">{{ s.lastAtMs | date: 'MMM d, h:mm a' }}</span>
    </label>
  </div>

  <div class="fh-none" *ngIf="!loading && !failed && !series.length">
    {{ '@issueFaultNoneReported' | translate }}
  </div>
  <div class="fh-none" *ngIf="!loading && failed">
    {{ '@issueFaultReadFailed' | translate }}
  </div>
</mat-dialog-content>

<div mat-dialog-actions class="fh-actions">
  <span class="fh-tally" *ngIf="series.length">
    {{ '@issueFaultTally' | translate: {
      shown: shownCount, total: series.length, reports: reportCount } }}
  </span>
  <button type="button" mat-raised-button color="primary"
          data-e2e="fault-history-done" (click)="close()">
    {{ '@close' | translate }}
  </button>
</div>
